export enum DetailsType {
  L4L,
  DEFAULT,
  BUDGET,
  RETAIL,
  ECOM,
}

export const DETAILS_SUFFIX = {
  [DetailsType.L4L]: 'L4L',
  [DetailsType.RETAIL]: 'NECom',
  [DetailsType.ECOM]: 'ECom',
  [DetailsType.DEFAULT]: '',
  [DetailsType.BUDGET]: 'Budget',
}
